import { Button, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, Spinner } from "@chakra-ui/react";

interface Props {
  isOpen: boolean;
  fullName: string;
  email: string;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

function ConfirmEnableModal({ isOpen, fullName, email, onClose, onConfirm, isLoading }: Props) {
  return (
    <Modal blockScrollOnMount={true} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirm Enabling</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction="column" alignItems="center">
            <Text mt={4}>
              Are you sure you want to enable the user{" "}
              <strong>{fullName}</strong>?
            </Text>
            <Text mt={2} color="gray.500">
              {email}
            </Text>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="green" mr={3} onClick={onConfirm} isDisabled={isLoading}>
            {isLoading ? <Spinner size="sm" /> : "Enable"}
          </Button>
          <Button variant="ghost" onClick={onClose} isDisabled={isLoading}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default ConfirmEnableModal;
